import Layout from "@/components/Layout";
import { Reveal } from "@/components/Reveal";
import { SITE } from "@/data/site";

function LegalShell({ title, children, testid }) {
  return (
    <Layout>
      <div className="pt-[124px] md:pt-[136px] lg:pt-[172px]">
        <div className="max-w-[900px] mx-auto px-6 md:px-12 py-20 md:py-28" data-testid={testid}>
          <Reveal>
            <p className="text-xs uppercase tracking-[0.25em] text-terracotta font-medium">SAPORÉ · Documenti</p>
            <h1 className="mt-3 font-serif text-4xl md:text-5xl text-charred tracking-tight">{title}</h1>
          </Reveal>
          <div className="mt-10 space-y-8 text-sm md:text-base text-charred/75 leading-relaxed">{children}</div>
        </div>
      </div>
    </Layout>
  );
}

const H = ({ children }) => <h2 className="font-serif text-2xl text-charred">{children}</h2>;

export function PrivacyPage() {
  return (
    <LegalShell title="Privacy Policy" testid="privacy-page">
      <div>
        <H>Titolare del trattamento</H>
        <p className="mt-2">
          <strong className="text-charred">{SITE.titolare}</strong><br />
          {SITE.address}<br />
          {SITE.piva}
        </p>
        <p className="mt-2">
          Per qualsiasi richiesta relativa alla privacy puoi rivolgerti al personale presso il punto vendita oppure telefonare al {SITE.phoneDisplay}.
        </p>
        <p className="mt-2 text-xs text-charred/50 italic">
          (Contatto e-mail privacy: in attesa di attivazione — da completare prima della pubblicazione del sito.)
        </p>
      </div>

      <div>
        <H>Dati che raccogliamo</H>
        <p className="mt-2">Questo sito raccoglie unicamente i dati che l'utente fornisce volontariamente:</p>
        <ul className="mt-3 space-y-2 list-none">
          <li className="flex gap-3"><span className="mt-2 w-1.5 h-1.5 rounded-full bg-terracotta shrink-0" aria-hidden="true" /><span><strong className="text-charred">Richieste di informazioni, ordini e preventivi per eventi:</strong> nome, numero di telefono, indirizzo e-mail e dettagli della richiesta (data, luogo, numero di partecipanti, eventuali esigenze alimentari).</span></li>
          <li className="flex gap-3"><span className="mt-2 w-1.5 h-1.5 rounded-full bg-terracotta shrink-0" aria-hidden="true" /><span><strong className="text-charred">Lista informativa "menù del giorno":</strong> nome e contatto (telefono o e-mail), forniti solo con consenso espresso.</span></li>
          <li className="flex gap-3"><span className="mt-2 w-1.5 h-1.5 rounded-full bg-terracotta shrink-0" aria-hidden="true" /><span><strong className="text-charred">Candidature di lavoro:</strong> dati forniti volontariamente tramite la sezione "Lavora con noi", soltanto quando questa sezione è attiva. Quando la sezione è disattivata non viene raccolto alcun dato.</span></li>
        </ul>
      </div>

      <div>
        <H>Finalità e base giuridica</H>
        <p className="mt-2">
          I dati forniti tramite richieste di informazioni, ordini o preventivi vengono utilizzati esclusivamente per rispondere alla richiesta (esecuzione di misure precontrattuali, art. 6.1.b GDPR).
          Gli aggiornamenti sul menù del giorno e sulle novità vengono inviati soltanto a chi ha dato il proprio consenso (art. 6.1.a GDPR), revocabile in qualsiasi momento.
          Quando la sezione "Lavora con noi" è attiva, i dati forniti volontariamente per una candidatura vengono trattati esclusivamente per la valutazione della candidatura.
        </p>
        <p className="mt-2">
          I dati non vengono utilizzati per finalità di marketing senza il consenso dell'interessato e non vengono ceduti a terzi.
        </p>
      </div>

      <div>
        <H>Tempi di conservazione</H>
        <p className="mt-2">
          I dati relativi a richieste e preventivi sono conservati per il tempo necessario a gestire la richiesta e gli eventuali adempimenti successivi. Le candidature sono conservate per un massimo di 12 mesi dall'invio. Le iscrizioni alla lista informativa restano attive fino alla richiesta di cancellazione.
        </p>
      </div>

      <div>
        <H>Servizi esterni utilizzati</H>
        <p className="mt-2">
          Il sito è ospitato su una piattaforma tecnica di hosting. Per la visualizzazione dei caratteri tipografici viene utilizzato Google Fonts (Google Ireland Ltd.), che può ricevere dati tecnici di connessione. I collegamenti a WhatsApp e Google Maps si attivano soltanto se l'utente li seleziona volontariamente: in quel caso si applicano le informative privacy dei rispettivi servizi.
        </p>
      </div>

      <div>
        <H>Diritti dell'interessato</H>
        <p className="mt-2">
          Puoi esercitare in qualsiasi momento i diritti previsti dagli articoli 15–22 del GDPR (accesso, rettifica, cancellazione, limitazione, opposizione, portabilità) rivolgendoti al personale presso il punto vendita o telefonando al {SITE.phoneDisplay}. Hai inoltre diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).
        </p>
      </div>

      <div>
        <H>Cookie</H>
        <p className="mt-2">Per le informazioni sui cookie e sugli strumenti tecnici utilizzati dal sito, consulta la Cookie Policy.</p>
      </div>
    </LegalShell>
  );
}

export function CookiePage() {
  return (
    <LegalShell title="Cookie Policy" testid="cookie-page">
      <div>
        <H>Cosa sono i cookie</H>
        <p className="mt-2">I cookie e gli strumenti analoghi (come la memoria locale del browser) permettono al sito di funzionare correttamente e di ricordare le scelte dell'utente.</p>
      </div>

      <div>
        <H>Strumenti realmente utilizzati da questo sito</H>
        <p className="mt-2">Il sito di SAPORÉ utilizza <strong className="text-charred">soltanto strumenti tecnici</strong>, che non richiedono consenso:</p>
        <ul className="mt-3 space-y-2 list-none">
          <li className="flex gap-3"><span className="mt-2 w-1.5 h-1.5 rounded-full bg-terracotta shrink-0" aria-hidden="true" /><span><strong className="text-charred">Preferenza sul consenso cookie</strong> — memorizza la scelta fatta nel banner (Accetta/Rifiuta) per non riproportelo a ogni visita.</span></li>
          <li className="flex gap-3"><span className="mt-2 w-1.5 h-1.5 rounded-full bg-terracotta shrink-0" aria-hidden="true" /><span><strong className="text-charred">Preferenza sul messaggio di benvenuto</strong> — evita di mostrare di nuovo il messaggio iniziale durante la stessa visita; si cancella alla chiusura del browser.</span></li>
        </ul>
        <p className="mt-3">
          <strong className="text-charred">Non sono attualmente installati cookie di profilazione, di marketing né strumenti di statistica o analisi delle visite.</strong> Se in futuro verranno attivati strumenti di misurazione non strettamente necessari, saranno caricati esclusivamente dopo il consenso espresso tramite il pulsante "Accetta" del banner.
        </p>
      </div>

      <div>
        <H>Servizi esterni</H>
        <p className="mt-2">
          Per i caratteri tipografici il sito si collega a Google Fonts (Google Ireland Ltd.). I collegamenti a WhatsApp e Google Maps si aprono solo su scelta dell'utente e rimandano a servizi esterni con proprie informative.
        </p>
      </div>

      <div>
        <H>Come gestire o modificare il consenso</H>
        <p className="mt-2">
          Puoi modificare la tua scelta in qualsiasi momento dalla voce "Gestisci preferenze cookie" nel piè di pagina del sito, oppure cancellando i dati di navigazione dal tuo browser.
        </p>
      </div>
    </LegalShell>
  );
}

const allergens = [
  "Cereali contenenti glutine", "Crostacei", "Uova", "Pesce", "Arachidi", "Soia",
  "Latte e derivati", "Frutta a guscio", "Sedano", "Senape", "Semi di sesamo",
  "Anidride solforosa e solfiti", "Lupini", "Molluschi",
];

export function AllergeniPage() {
  return (
    <LegalShell title="Informazioni su allergeni e ingredienti" testid="allergeni-page">
      <div>
        <H>Informazioni importanti</H>
        <p className="mt-2">I nostri prodotti possono contenere o essere entrati in contatto con sostanze o prodotti che provocano allergie o intolleranze. Prima di effettuare un ordine, invitiamo il cliente a comunicare al personale la presenza di eventuali allergie, intolleranze o particolari esigenze alimentari.</p>
        <p className="mt-2">Le informazioni complete sugli allergeni presenti nelle singole preparazioni sono disponibili presso il punto vendita.</p>
      </div>
      <div>
        <H>Elenco degli allergeni (Reg. UE 1169/2011)</H>
        <ul className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
          {allergens.map((a) => (
            <li key={a} className="flex items-center gap-3">
              <span className="w-1.5 h-1.5 rounded-full bg-terracotta shrink-0" aria-hidden="true" /> {a}
            </li>
          ))}
        </ul>
      </div>
      <p className="text-xs text-charred/50">Non possiamo garantire l'assenza totale di contaminazioni accidentali, poiché la cucina non dispone di ambienti e attrezzature completamente separati per ogni allergene.</p>
    </LegalShell>
  );
}
